import * as $ from 'jquery';
import 'bootstrap';

export class videoEmbedComponent{
	pauseVideo(): any{
		let _self = this;
		$('.video-img').parent().click(function () {
			if($(this).children('.video-img').get(0).paused){
					$(this).children('.video-img').get(0).play();
					$(this).children('.playpause').fadeOut();
			}else{
				 $(this).children('.video-img').get(0).pause();
					$(this).children('.playpause').fadeIn();
			}
		});
	}
}

let scope:Element = document.querySelector('.video-component');
if (scope){
	try {
	let videoembedcomponent = new videoEmbedComponent();
			videoembedcomponent.pauseVideo();
	} catch(e) {console.error(e);}
}
